import { Link } from "react-router-dom";
import { Siren } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { StatusFromMap, lazyPage } from "@vixio/ui";
import "./api";
import { SEVERITY } from "./api";
import { useAlerts } from "./widget-data";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const SignalsPage = lazyPage(() => import("./SignalsPage"), "SignalsPage");

function SignalsWidget() {
  const org = useOrg();
  const open = (useAlerts(org.id).data ?? []).filter((a) => a.status === "aberto").slice(0, 5);
  if (!open.length) return <p className="muted">Nenhum sinal aberto.</p>;
  return (
    <ul className="vx-stack" style={{ gap: 8, margin: 0, padding: 0, listStyle: "none" }}>
      {open.map((a) => (
        <li key={a.id} className="vx-row vx-row--between" style={{ flexWrap: "nowrap", gap: 12 }}>
          <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><Link to="/gestao/sinais">{a.title}</Link></span>
          <StatusFromMap map={SEVERITY} value={a.severity} />
        </li>
      ))}
    </ul>
  );
}

export default defineModuleUi({
  key: "alerts",
  title: "Sinais",
  domain: "governance",
  icon: Siren,
  menu: [{ path: "/gestao/sinais", label: "Sinais", minRole: "member", icon: Siren, order: 15, keywords: "alerta ajuste rota contratar pausa teto horas concentração pm3" }],
  routes: [{ path: "/gestao/sinais", element: <SignalsPage />, minRole: "member" }],
  widgets: [{ key: "alerts.open", title: "Sinais abertos", minRole: "member", span: 1, order: 4, element: SignalsWidget }],
});
